import React from 'react';
import './AccessibilityPage.css';

export const AccessibilityContent = () => (
  <div className="accessibility-content">
    <p>I am trying to make this site as accessible as possible.</p>
    <p className="update">Last updated: November 9, 2009</p>
  </div>
);

export default AccessibilityContent;
